import React, { useEffect, useState } from "react";
import { Dialog } from 'primereact/dialog';
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import { Button } from "primereact/button";

import RateContractSearch from "../../PostRequirement/components/RateContractSearch";

import Loading from "../../../common/Loading";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { fetchMaterialBrands, fetchMaterialUoms, fetchMaterialCategories } from "../../../services/redux/reducers/commonThunk";
import { useDispatch, useSelector } from "react-redux";
import { addProductIntoBuyerRequirement } from "../../../services/api/buyerReq";
import { getCompanyERPCodeMapByCompanyId, getVMICompanyERPCodeMapByCompanyId } from "../../../services/api/companyERPCodeMap";
import { getBuyerRateContractByCompanyIdAndBranchId, getVMIBuyerRateContractByCompanyIdAndBranchId } from '../../../services/api/buyerRateContracts';
import "../index.jsx"
import { getMaterialMasterAndTempMaterialIdsById } from "../../../services/api/materialMaster.js";

import MaterialSearch from "../../PostRequirement/components/MaterialSearch.jsx";
import ProductsSection from "../../PostRequirement/components/ProductsSection.jsx";
import { ThreeDots } from "react-loader-spinner";


function AddProduct(props) {
    const { requirement, setVisibleAddProduct, buyerRequirementItems, company } = props

    const [rateContractProducts, setRateContractProducts] = useState([])
    const [companyERPCodeMaps, setCompanyERPCodeMaps] = useState([])

    const [visisbleAddRCProducts, setVisisbleAddRCProducts] = useState(false)
    const [visisbleAddAdhocProducts, setVisisbleAddAdhocProducts] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch()
    const brandsData = useSelector(state => state.common.materialBrands)
    const industryData = useSelector(state => state.common.materialCategories)
    const uomsData = useSelector(state => state.common.materialUOMs)

    const [activeTab, setActiveTab] = useState(0)
    const [products, setProducts] = useState([])

    const productsWithErpCode = products.filter(eachProduct => eachProduct.isMappedProduct)
    const productsWithoutErpCode = products.filter(eachProduct => !eachProduct.isMappedProduct)

    useEffect(() => {
        setIsModalLoading(true)
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialCategories())
        dispatch(fetchMaterialUoms())
        if(uomsData.length > 0 && brandsData.length > 0 && industryData.length > 0){
            getCompanyERPCodeMapData()
        }
    }, [uomsData, brandsData, industryData])

    const getCompanyERPCodeMapData = async () => {
        let response = null
        if (requirement.reqTagId === 4) {
            response = await getVMICompanyERPCodeMapByCompanyId({ companyId: requirement.companyId, statusId: 1, warehouseIds: [requirement.pmWarehouseId] })
        }
        else {
            response = await getCompanyERPCodeMapByCompanyId({ companyId: requirement.companyId, statusId: 1 })
        }

        if(response.failure){
            setIsModalLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'Company ERP codes', detail: response.data.error, life: 3000}))
        }
        else{
            const modifiedCompanyERPCodeMapData = response?.data.map(eachERP => {
                const prodUOM = uomsData.find(eachUOM => eachUOM.UOM === eachERP.UOM)
                return {...eachERP, categoryId: eachERP?.categoryId, materialUOMId: prodUOM?.materialUOMId}
            })
            setCompanyERPCodeMaps(modifiedCompanyERPCodeMapData)
        }

        let responseRC = null
        if (requirement.reqTagId === 4) {
            responseRC = await getVMIBuyerRateContractByCompanyIdAndBranchId({ companyId: requirement.companyId, branchIds: [0, requirement.branchId], statusId: 1, warehouseIds: [requirement.pmWarehouseId] })
        }
        else{
            responseRC = await getBuyerRateContractByCompanyIdAndBranchId({ companyId: requirement.companyId, branchIds: [0, requirement.branchId], statusId: 1 })
        }
        
        if(responseRC.failure){
            setIsModalLoading(false)
            dispatch(raiseToast({severity:'error', summary: 'Rate Contract Products', detail: responseRC.data.error, life: 3000}))
        }else{
            const modifiedRateContractsList = responseRC.data.map(eachProduct => {
                const erpCode = eachProduct.companyERPCode ? `${eachProduct.companyERPCode} |` : ''
                const productString = `${eachProduct.materialId} | ${erpCode} ${eachProduct.companyProdName} | ${eachProduct.companyProdSpec}`

                const materialUOM = uomsData.find(eachUOM => eachUOM.UOM === eachProduct.UOM)
                const relatedBrand = brandsData.find(eachBrand => eachBrand.brandId === eachProduct.brandId)
                const relatedCategory = industryData.find(eachCategory => eachCategory.categoryId === eachProduct.categoryId)

                return {
                    ...eachProduct, 
                    rateContractProductId: uuidv4(), 
                    productString, 
                    materialUOMId: materialUOM?.materialUOMId, 
                    brandName: relatedBrand?.brandName, 
                    categoryName: relatedCategory?.categoryName
                }
            })
            // console.log('rate contract', modifiedRateContractsList)
            setRateContractProducts(modifiedRateContractsList)
            // setIsLoading(false)
        }
        setIsModalLoading(false)
    }

    // new
    const handleAddProductWithErpCode = () => {
        const newProduct = {
            productId: uuidv4(),
            companyERPCode: '',
            materialId: '',
            productName: '',
            variantName: '',
            specification: '',
            categoryId: null,
            brandId: null,
            uomValue: null,
            materialUOMId: null,
            quantity: '',
            isMappedProduct: true,
            buyerRateContractId: null,
            companyERPCodeMapId: null,
            isOverRiddedProduct: false,
            isMaterialMasterProduct: false
        }

        const newProductsList = [...products, newProduct]
        setProducts(newProductsList)
    }

    const handleAddProductWithoutErpCode = () => {
        const newProduct = {
            productId: uuidv4(),
            companyERPCode: '',
            materialId: '',
            productName: '',
            // variantName: '',
            specification: '',
            category: null,
            brand: null,
            uomValue: null,
            materialUOMId: null,
            quantity: '',
            isMappedProduct: false,
            buyerRateContractId: null,
            companyERPCodeMapId: null, //Always null
            isOverRiddedProduct: false,
            isMaterialMasterProduct: false
        }

        const newProductsList = [...products, newProduct]
        setProducts(newProductsList)
    }

    const handleRemoveProduct = (id) => {
        const newProductsList = products.filter(eachProduct => eachProduct.productId !== id)
        setProducts([...newProductsList])
    }

    const handleProductChange = (id, name, value) => {
        const updatedProductsList = products.map(eachProduct => {
            if(eachProduct.productId === id){  
                return { ...eachProduct, [name]: value } 
            }
            return eachProduct
        })
        // console.log("updatedProductsList", updatedProductsList)
        setProducts([...updatedProductsList])
    }

    const handleAutoFillProductData = (id, productData) => {
        const updatedProducts = products.map(eachProduct => {
            if(eachProduct.productId === id){  
                return {productId: id, ...productData} 
            }
            return eachProduct
        })
        setProducts([...updatedProducts])
    }

    const getUpdatedProductWithMaterialCode = async (id, companyERPCode, materialId) => {
        
        const materialDetails = await getMaterialMasterAndTempMaterialIdsById({ materialId: materialId, excludeTempMaterialsUnderDiffClientReq: true, companyId: requirement.companyId })
            if(materialDetails.failure){
                return {error: "raise error", errorMsg: materialDetails.data.error}
            }
            else{
                const material = materialDetails?.data
                // console.log("material", material)

                if(!material) dispatch(raiseToast({severity:'error', detail: "Material ID not found", life: 3000}))

                const materialUOMDetails = uomsData.find(eachUOM => eachUOM.UOM === material?.UOM)
                let materialUOMValue = material?.UOMValue 
                if(!material?.UOMValue && material?.materialId.toString().length >= 7){
                    materialUOMValue = 1
                }

                const updatedProducts = products.map(eachProduct => {
                    if(eachProduct.productId === id){
                        return {
                            // ...eachProduct, 
                            productId: id,
                            companyERPCode: requirement.orderTypeId === 3 ? material?.materialId ? material?.materialId : '' : '', 
                            materialId: material?.materialId ? material?.materialId : '',
                            productName: material?.productName ? `${material?.productName}-${material?.variantName ? material?.variantName : ''}` : '',
                            materialMasterProductName: material?.productName ? material?.productName : null,
                            specification: material?.productSpecification ? material?.productSpecification : '',
                            materialMasterSpecification: material?.productSpecification ? material?.productSpecification : null,
                            // brand: material?.brandId ,
                            brand: material?.brandId ? material?.brandId : null,
                            category: material?.categoryId ? material?.categoryId : null,
                            materialUOMId: materialUOMDetails ? materialUOMDetails.materialUOMId : null,
                            uomValue: materialUOMValue ? materialUOMValue : '',
                            isMappedProduct: false,
                            isMaterialMasterProduct: material ? true : false,
                            buyerRateContractId: null,
                            companyERPCodeMapId: null,
                            isOverRiddedProduct: false
                        } 
                    }
                    return eachProduct
                })
                return updatedProducts
            } 
    }

    const getEmptiedProducts = (id, companyERPCode, materialId) => {
        // console.log("getEmptiedProducts triggers")
        const updatedProducts = products.map(eachProduct => {
            if(eachProduct.productId === id){
                return {
                    // ...eachProduct,
                    productId: id,
                    companyERPCode: companyERPCode, 
                    materialId: materialId, 
                    productName: '',
                    // variantName: '',
                    specification: '',
                    category: null,
                    brand: null,
                    uomValue: null,
                    materialUOMId: null,
                    quantity: '',
                    isMappedProduct: false,
                    buyerRateContractId: null,
                    companyERPCodeMapId: null, 
                    isOverRiddedProduct: false,
                    isMaterialMasterProduct: false
                } 
            }
            return eachProduct
        })

        return updatedProducts
    }
    
    const handleMoveToSectiontwo = async (id, companyERPCode, materialId) => {

        //We need to call material Id api for only orderType = 1, 3

        let updatedProducts = []
        if(requirement.orderTypeId === 2) return

        if(requirement.orderTypeId === 1){
            if(materialId){
                setIsLoading(true)
                updatedProducts = await getUpdatedProductWithMaterialCode(id, companyERPCode, materialId)
                setIsLoading(false)
                
                if(updatedProducts.error === "raise error") return dispatch(raiseToast({severity:'error', summary: 'Material Codes', detail: updatedProducts.errorMsg, life: 3000}))
            }
            else if(companyERPCode){
                updatedProducts = getEmptiedProducts(id, companyERPCode, materialId)
                dispatch(raiseToast({severity:'warn', detail:'Company ERP code is not mapped. Product moved to unmapped products section', life: 3000}))
            }
        }
        
        setActiveTab(1)
        setProducts([...updatedProducts])
    } 

    const handleUnmappedProductsMoves = async (id, companyERPCode, materialId) => {
        //We need to call material Id api for only orderType = 1, 3

        let updatedProducts = []
        if(requirement.orderTypeId === 2) return

        if(requirement.orderTypeId === 1){
            if(materialId){
                setIsLoading(true)
                updatedProducts = await getUpdatedProductWithMaterialCode(id, companyERPCode, materialId)
                setIsLoading(false)
                
                if(updatedProducts.error === "raise error") return dispatch(raiseToast({severity:'error', summary: 'Material Codes', detail: updatedProducts.errorMsg, life: 3000}))
            }
            // else if(companyERPCode){
            //     updatedProducts = getUpdatedProducts(id, companyERPCode, materialId)
            // }
        }

        else if(requirement.orderTypeId === 3){
            //For Stock, companyERPCode = materialId
            setIsLoading(true)
            updatedProducts = await getUpdatedProductWithMaterialCode(id, companyERPCode, materialId)
            setIsLoading(false)

            if(updatedProducts.error === "raise error") return dispatch(raiseToast({severity:'error', summary: 'Material Codes', detail: updatedProducts.errorMsg, life: 3000}))
        }

        setActiveTab(1)
        setProducts([...updatedProducts])
    }

    const handleActiveTab = (num) => { //Not working!
        // console.log('active tab', num)
        setActiveTab(num)
    }

    const handleRemoveAllSec1Products = (products) => {
        const isProductsWithERP = products.find(eachProduct => eachProduct.isMappedProduct)
        if(isProductsWithERP){
            if(window.confirm("Do you want to remove all the products in mapped products section?")){
                const filteredProductsData = products.filter(eachProduct => !eachProduct.isMappedProduct)
                setProducts(filteredProductsData)
            }
        }
    }

    const handleRemoveAllSec2Products = (products) => {
        const isProductsWithERP = products.find(eachProduct => !eachProduct.isMappedProduct)
        if(isProductsWithERP){
            if(window.confirm("Do you want to remove all the products in unmapped products section?")){
                const filteredProductsData = products.filter(eachProduct => eachProduct.isMappedProduct)
                setProducts(filteredProductsData)
            }
        }
    }

    const handleAddProduct = async () => {
        // console.log("submit trigger")
        if(productsWithErpCode.length === 0 && productsWithoutErpCode.length === 0){
            return dispatch(raiseToast({severity:'error', detail: "Please Add Products", life: 3000}))   
        }


        const relatedBuyerReqItems = buyerRequirementItems.filter(eachReqItem => eachReqItem.buyerReqId === requirement.buyerReqId)
        const materialIds = relatedBuyerReqItems.map(eachReqItem => eachReqItem.materialId)
        // console.log("materialIds", materialIds)

        const allProducts = [...productsWithErpCode, ...productsWithoutErpCode]

        const isMaterialIDAlredyPresent = allProducts.some(eachProduct => {
            if(eachProduct.materialId){
                // console.log("cond", materialIds.includes(eachProduct.materialId))

                if(materialIds.includes(eachProduct.materialId)) dispatch(raiseToast({severity: 'error', detail: `The materialID ${eachProduct.materialId} is already added in the requirement`, life: 3000}))
                return materialIds.includes(eachProduct.materialId)
            }
        })

        if(isMaterialIDAlredyPresent) return

        const invalidMappedProduct = productsWithErpCode.some((eachProduct, index) => {
            if (!eachProduct.quantity || parseFloat(eachProduct.quantity) === 0) {
                dispatch(raiseToast({severity: 'error', detail: `Please add quantity for material code ${eachProduct.materialId} in mapped products section`, life: 3000}));
                return true
            }
            else if(!eachProduct.materialId){
                dispatch(raiseToast({severity: 'error', detail: `Please add material code for product number ${index+1} in mapped products section`, life: 3000}));
                return true
            }
            // else if(!eachProduct.companyERPCode){
            //     dispatch(raiseToast({severity: 'error', detail: `Please add client ERP code for product number ${index+1} in mapped products section`, life: 3000}));
            //     return true
            // }
            return false
        })
        if(invalidMappedProduct) return

        const unmappedProducts = []
        const invalidUnmappedProducts = productsWithoutErpCode.some((eachProduct, index) => {
            if (!eachProduct.quantity && parseFloat(eachProduct.quantity) === 0) {
                dispatch(raiseToast({severity: 'error', detail: `Please add quantity for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            //validations for brand
            if (!eachProduct.category) {
                dispatch(raiseToast({severity: 'error', detail: `Please select category for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            if (!eachProduct.materialUOMId) {
                dispatch(raiseToast({severity: 'error', detail: `Please select UOM for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            if (!eachProduct.productName) {
                dispatch(raiseToast({severity: 'error', detail: `Please add product name for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            if (!eachProduct?.brand?.brandId && !(typeof(eachProduct?.brand) === 'number')) {
                // console.log("brand valid", !eachProduct?.brand?.brandId, !(typeof(eachProduct?.brand) === 'number'))
                dispatch(raiseToast({severity: 'error', detail: `Please add brand for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            if (!eachProduct.specification) {
                dispatch(raiseToast({severity: 'error', detail: `Please add specification for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            if (!eachProduct.uomValue) {
                dispatch(raiseToast({severity: 'error', detail: `Please add uom value for product number ${index+1} in unmapped products section`, life: 3000}));
                return true
            }
            // unmappedProducts.push(eac)
            return false
        })
        if(invalidUnmappedProducts) return


        //check duplicacy
        
        let duplicateMaterialIds = []
        let duplicateERPCodes = []
        allProducts.filter((item, index, array) => {
            const isDuplicate = array.slice(0, index).some((prevItem) => {
                return prevItem.materialId === item.materialId
            })
            if (isDuplicate) {
                duplicateMaterialIds.push(item.materialId)
            }

            const isERPDuplicate = array.slice(0, index).some((prevItem) => {
                return prevItem.companyERPCode === item.companyERPCode
            })
            if (isERPDuplicate) {
                duplicateERPCodes.push(item.companyERPCode)
            }
        })
        
        duplicateMaterialIds = _.compact(duplicateMaterialIds)
        if (duplicateMaterialIds.length > 0) {
            return dispatch(raiseToast({severity:'error', summary: 'Duplicate Material Codes', detail: `Please remove products with same material Codes. Duplicate Material Codes: ${duplicateMaterialIds.join(', ')}`, life: 3000})) 
        }
        
        duplicateERPCodes = _.compact(duplicateERPCodes)
        // console.log("duplicateERPCodes", duplicateERPCodes)
        if (duplicateERPCodes.length > 0) {
            return dispatch(raiseToast({severity:'error', summary: 'Duplicate Client ERP Codes', detail: `Please remove products with same client ERP codes. Duplicate Client ERP Codes: ${duplicateERPCodes.join(', ')}`, life: 3000})) 
        }

        //repetition of mapped products in unmapped products
        let duplicateMappedProducts = false
        if(requirement.orderTypeId === 1){
            duplicateMappedProducts = productsWithoutErpCode.some(eachProduct => {
                if(eachProduct.companyERPCode){
                    const relatedCompanyERPCodeMap = companyERPCodeMaps.find(eachERP => eachERP.companyERPCode === eachProduct.companyERPCode)
                    // console.log("relatedCompanyERPCodeMap", relatedCompanyERPCodeMap)
                    if(relatedCompanyERPCodeMap){
                        dispatch(raiseToast({severity:'error', detail: `product with client ERP code ${eachProduct.companyERPCode} is a mapped product. Please move the product to mapped product section.`}))
                        return true 
                    }
                }
                if(eachProduct.materialId){
                    const relatedCompanyERPCodeMap = companyERPCodeMaps.find(eachERP => eachERP.materialId === eachProduct.materialId)
                    if(relatedCompanyERPCodeMap){
                        dispatch(raiseToast({severity:'error', detail: `product with material code ${eachProduct.materialId} is a mapped product. Please move the product to mapped product section.`}))
                        return true 
                    }
                }
                return false
            })
        }
        if(duplicateMappedProducts) return

        let productsWithERPCodeMap = []
        if(productsWithErpCode.length > 0){
            productsWithERPCodeMap = productsWithErpCode.map(eachProduct => ({
                materialId: eachProduct.materialId,
                qty: parseFloat(eachProduct.quantity), //even after making input to take only int, still the output is in string
                buyerRateContractId: eachProduct.buyerRateContractId,
                companyERPCodeMapId: eachProduct?.companyERPCodeMapId ? eachProduct?.companyERPCodeMapId : null,
                productId: eachProduct?.productId,
                companyERPCode: eachProduct?.companyERPCode ? eachProduct?.companyERPCode : null
            }))
        }

        let productsWithoutERPCodeMap = []
        if(productsWithoutErpCode.length > 0){
            productsWithoutERPCodeMap = productsWithoutErpCode.map(eachProduct => {
                const productBrandId = typeof(eachProduct.brand) === "number" ? eachProduct.brand : eachProduct.brand?.brandId
                const productCategoryId = typeof(eachProduct.category) === "number" ? eachProduct.category : eachProduct.category?.categoryId

                const companyERPUOM = uomsData.find(eachUOM => eachUOM.materialUOMId === eachProduct.materialUOMId)?.UOM
                const companyERPCategory = industryData.find(eachCategory => eachCategory.categoryId === productCategoryId)?.industryName

                return {
                    productId: eachProduct?.productId,
                    companyId: requirement.companyId,
                    companyERPCode: eachProduct?.companyERPCode ? eachProduct?.companyERPCode : null,
                    materialId: eachProduct?.materialId,
                    companyERPCategory: companyERPCategory,  //Get this
                    companyERPUOM: companyERPUOM, //get this
                    productName: eachProduct.productName,
                    variantName: eachProduct?.variantName ? eachProduct?.variantName : null,
                    specification: eachProduct.specification,
                    productSpecifications: eachProduct.specification,  //remove extras
                    uomValue: eachProduct.uomValue,
                    brandId: productBrandId,
                    categoryId: productCategoryId,
                    buyerRateContractId: eachProduct?.buyerRateContractId,
                    UOM: eachProduct.materialUOMId,  //remove extras
                    UOMValue: eachProduct.uomValue, //remove extras
                    qty: parseFloat(eachProduct.quantity),
                }
            })
        }

        const items = { productsWithERPCodeMap, productsWithoutERPCodeMap }

        if (window.confirm("Do you want to add this products ?")) {
            setIsLoading(true)
            const addProductResponse = await addProductIntoBuyerRequirement({ buyerRequirement: requirement, items: items })

            if(addProductResponse.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'add product', detail: addProductResponse.data.error, life: 3000}))
            }
            else{
                setIsLoading(false)
                setProducts([])
                setVisibleAddProduct()
                dispatch(raiseToast({ severity: 'success', detail: "Products added successfully", life: 3000 }))
            }
        }
    }

    let showAddProduct = false
    if(requirement.orderTypeId === 1 && requirement.companyId){
        showAddProduct = true
    }
    else if(requirement.orderTypeId === 3 && requirement.companyId && requirement.branchId){
        showAddProduct = true
    }

    // console.log("productsWithErpCode", productsWithErpCode)
    // console.log("productsWithoutErpCode", productsWithoutErpCode)
    // console.log("companyERPCodeMaps", companyERPCodeMaps)

    return (
        <div className="flex flex-column justify-content-between add-product">
            <Loading visible={isLoading} />
            {
                isModalLoading ?
                    <div className="flex justify-content-center align-items-center h-full">
                        <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={true} />
                    </div>
                    :
                    <div className="flex flex-column justify-content-between" style={{ minHeight: "300px" }}>
                        <ProductsSection
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            requirement={requirement}
                            productsWithErpCode={productsWithErpCode}
                            productsWithoutErpCode={productsWithoutErpCode}
                            handleProductChange={handleProductChange}
                            handleRemoveProduct={handleRemoveProduct}
                            brandsData={brandsData}
                            uomsData={uomsData}
                            industryData={industryData}
                            handleAutoFillProductData={handleAutoFillProductData}
                            handleMoveToSectiontwo={handleMoveToSectiontwo}
                            handleActiveTab={handleActiveTab}
                            companyERPCodeMaps={companyERPCodeMaps}
                            setIsLoading={setIsLoading}
                            products={products}
                            setProducts={setProducts}
                            showAddProduct={showAddProduct}
                            handleAddProductWithErpCode={handleAddProductWithErpCode}
                            handleUnmappedProductsMoves={handleUnmappedProductsMoves}
                            handleAddProductWithoutErpCode={handleAddProductWithoutErpCode}
                            handleRemoveAllSec1Products={handleRemoveAllSec1Products}
                            setVisisbleAddRCProducts={setVisisbleAddRCProducts}
                            setVisisbleAddAdhocProducts={setVisisbleAddAdhocProducts}
                            handleRemoveAllSec2Products={handleRemoveAllSec2Products}
                        />
                        <Dialog header="Add RC Products" className="add-rc-product-dialog" visible={visisbleAddRCProducts} onHide={() => setVisisbleAddRCProducts(false)} style={{ width: '55vw', height: '80vh' }}>
                            <RateContractSearch rateContractProducts={rateContractProducts} products={products} setProducts={setProducts} company={company} />
                        </Dialog>
                        <Dialog header="Add Products" className="add-rc-product-dialog" visible={visisbleAddAdhocProducts} onHide={() => setVisisbleAddAdhocProducts(false)} style={{ width: '55vw', height: '80vh' }}>
                            <MaterialSearch companyERPCodeMaps={companyERPCodeMaps} uomsData={uomsData} products={products} setProducts={setProducts} companyId={requirement.companyId} requirement={requirement} />
                        </Dialog>
                        <div className="mt-1 flex justify-content-end align-self-end">
                            <Button label="Add Product" className="small-btn" outlined onClick={handleAddProduct} />
                            <Button label="Cancel" className="ml-2 small-btn" severity="danger" outlined onClick={setVisibleAddProduct} />
                        </div>
                    </div>
            }
        </div>
    )
}

export default AddProduct;